import { ReactNode } from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";

const useStyles = makeStyles({
  inputContainer: {
    minWidth: "30%",
  },
});

interface InputWrapperProps {
  children: ReactNode;
  /** Extra classes for the wrapper (the flex item in a row), e.g. per-field sizing. */
  className?: string;
}

const InputWrapper = ({ children, className }: InputWrapperProps) => {
  const styles = useStyles();

  return <div className={mergeClasses(styles.inputContainer, className)}>{children}</div>;
};

export default InputWrapper;
